import netsAgentStatusCompact from './nets-agent-status-compact';

export default angular
  .module('app.agent-status-compact', [])
  .component('netsAgentStatusCompact', netsAgentStatusCompact);
